export { default } from "./text";
